import { IStoreIntState } from ".";
import { AsyncActionState } from "../../standard-actions/async-action";
import { pageTitle } from "../../../applications/self-service-store/utils/page-titles-constants";
export const METRIC_STATUS_PLANS = "Offers";
export const HELP_BTN = "Help";
export const TAB_LOCATIONS = "Locations";
export const TAB_NETWORK_SERVICES = "Network services";
export const CARD_SUB_HEADING_FOR_NETWORK_PERFORMANCE = "Network and internet";
export const TAB_MOBILE_DATA_USAGE = "Mobile data usage";
export const HEAD_MOBILITY_SER = "StoreInt Services";
export const HEAD_SEARCH_RESULTS = "Search results";
export const LBL_RETURN_TO = "Return to";
export const LBL_BILLING_NUMBER = "Billing Number";

export const initialState: Readonly<IStoreIntState> = Object.freeze({
    selfServiceStore: {
        data: {
            records: [],
        },
        status: AsyncActionState.NotStarted,
    },
    featureFlagsData: {
        data: {
            accessToDownloadAttachments: false,
            isStrategicUser: false,
            csc: false,
            mobServiceChange: false,
            viewAggregatedYPSpage: false,
        },
        status: AsyncActionState.NotStarted,
    },
    userProfileDetails: {
        status: AsyncActionState.NotStarted,
        data: null,
    },
    tokens: {
        customerProfile: {
            status: AsyncActionState.NotStarted,
            data: { profile: "", active: false },
        },
    },
    breadcrumbData: [
        {
            label: pageTitle.dashboard,
            active: false,
            disabled: false,
            link: "/",
        },
    ],
    ableBreadcrumbData: [
        {
            label: pageTitle.dashboard,
            active: false,
            to: "/",
        },
    ],
    orderSummary: {
        status: AsyncActionState.NotStarted,
        data: {
            ordersTotal: 0,
            ordersAtRisk: 0,
            ordersDelayed: 0,
            ordersOnTrack: 0,
            ordersClosed: 0,
            isPartialResponse: null,
        },
    },
    activeServices: {
        status: AsyncActionState.NotStarted,
        data: [],
    },
    cartInfo: {
        status: AsyncActionState.NotStarted,
        data: [],
        orderStatus: ''
    },
    emptyCartData: {
        data: {
            emptyCart: {},
        },
        status: AsyncActionState.NotStarted,
    },
    cableTypeOptions: {
        status: AsyncActionState.NotStarted,
        data: {
            zEndRackType: [],
            popName: "",
            onnet:"",
            cableType: [],
            contract: {},
        },
        error: "",
    },
    serviceIdsOptions: {
        status: AsyncActionState.NotStarted,
        data: {
            services: [],
            popName: "",
        },
        error: "",
    },
    connectorTypeOptions: {
        status: AsyncActionState.NotStarted,
        data: {},
        error: "",
    },
    cableConfigurations: {
        status: "notUpdated",
        dataCenter: "",
        popName: "",
        dataCenterAddress: "",
        numberOfCables: 1,
        configurationDetails: {},
    },
    fileUploads: {
        status: AsyncActionState.NotStarted,
        data: {}
    },
    billingAccounts: {
        status: AsyncActionState.NotStarted,
        data: {},
    },
    addToCart: {
        status: AsyncActionState.NotStarted,
        message: "",
        data:{
            message: '',
        },
        code: 401,
    },
    cablesPrice: {
        status: AsyncActionState.NotStarted,
        data: {},
        error: "",
    },
    currencyRate: {
        data: {
            code: 1,
            message: "",
            fromCurrency: "USD",
            toCurrency: "USD",
            amount: 1,
            rateType: "",
            date: "",
            convertedAmount: "1.00",
            exchangeRate: "1.00000",
        },
        status: AsyncActionState.NotStarted,
        error:''
    },
    submitOrder : {
        status: AsyncActionState.NotStarted,
        message: '',
        opportunityIds:[],
        code: 401
    },
    completeCurrencyRate: {
        data: {
            code: 1,
            message: "",
            fromCurrency: "USD",
            toCurrency: "USD",
            rateData: {}
        },
        status: AsyncActionState.NotStarted,
        error:''
    },
},
);
